import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Cookie, X } from 'lucide-react';

export const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookie_consent');
    if (!cookieConsent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setShowBanner(false);
  };

  const handleClose = () => {
    localStorage.setItem('cookie_consent', 'closed');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-2xl border border-[#D4AF37]/20 overflow-hidden">
        <div className="p-4 sm:p-6">
          <div className="flex items-start gap-4">
            {/* Icon */}
            <div className="hidden sm:flex w-12 h-12 bg-gradient-to-br from-[#D4AF37] to-[#FFD700] rounded-full items-center justify-center flex-shrink-0">
              <Cookie className="w-6 h-6 text-white" />
            </div>

            {/* Content */}
            <div className="flex-1">
              <h3 className="font-bold text-gray-900 text-lg mb-2">
                🍪 Cookie-Hinweis
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                Wir verwenden Cookies, um Dir die bestmögliche Erfahrung auf unserer Website zu bieten. 
                Diese Cookies sind für den Betrieb der Website notwendig und helfen uns, die Nutzung 
                zu analysieren und die Website zu verbessern. Weitere Informationen findest Du in unserer{' '}
                <a 
                  href="/datenschutz-agb" 
                  className="text-[#D4AF37] hover:text-[#B8960C] underline"
                >
                  Datenschutzerklärung
                </a>.
              </p>

              {/* Buttons */}
              <div className="flex flex-col sm:flex-row gap-3">
                <Button
                  onClick={handleAccept}
                  className="bg-gradient-to-r from-[#D4AF37] to-[#FFD700] hover:from-[#B8960C] hover:to-[#D4AF37] text-white shadow-lg"
                >
                  Verstanden
                </Button>
                <a 
                  href="/datenschutz-agb"
                  className="inline-flex items-center justify-center px-4 py-2 border border-[#D4AF37] text-[#D4AF37] rounded-md hover:bg-[#D4AF37]/10 transition-colors text-sm font-medium"
                >
                  Mehr erfahren
                </a>
              </div>
            </div>

            {/* Close Button */}
            <button
              onClick={handleClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
              aria-label="Schließen"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
